<template>
  <div class="contain">
    <div class="sfz-pic" >
      身份证识别(拍照/照片)
      <input ref="picInput"   @change="uploadPic"  type="file" accept="image/*" />
    </div>
    <div class="mask" v-if="loadding">
      <van-loading type="spinner" color="white" />
    </div>
  </div>
</template>

<style scoped="">
  .sfz-pic{ display: inline-block; height: 100%; width: 100%;   position: relative ; margin: 10px auto}
  .sfz-pic input{width: 100%;  height: 100%;position: absolute; top:0 ; left: 0; opacity: 0}
  .tip{font-size: 12px; color: #999  ; margin-top: 20px}
</style>


<script>
import Vue from "vue";
import {
  Popup,
  Toast,
  Cell,
  CellGroup,
  Icon,
  Search,
  Checkbox,
  CheckboxGroup
} from "vant";

Vue.use(Popup)
  .use(Toast)
  .use(Cell)
  .use(CellGroup)
  .use(Icon)
  .use(Search)
  .use(Checkbox)
  .use(CheckboxGroup);

export default {
  name: "IdCardPicker",
  props: {

  },
  data() {
    return {
      cardPic: '',
      loadding:false,
    };
  },
  computed:{
  },
  mounted() {
  },
  watch: {

  },
  methods: {

    uploadPic(event){
      let that = this;
      if(that.loadding){
        return false;
      }
      that.loadding = true;
      let inputDOM = this.$refs['picInput'];
      // 通过DOM取文件数据
      let file = inputDOM.files[0];
      if(inputDOM.files.length>1){
        that.$toast.center('每次请选择1张图片');
        that.loadding = false;
        return false;
      }
      let size = Math.floor(file.size / 1024);
      if (size > 10*1024*1024) {
        that.$toast.center('请选择10M以内的图片');
        that.loadding = false;
        return false
      }

      console.log(file);

      let ossAccessTokenURL = 'https://api.ccago.dierqudao.com/core/attachment/aliOssSts';
      let ossFileURL= 'https://ccago.oss-cn-hangzhou.aliyuncs.com';
      OSS.urllib.request(ossAccessTokenURL, {method: 'GET'}, function (err, response) {
        let result;
        if (err) {
          that.$toast.$toast('上传异常:' + err);
          that.loadding = false;
          console && console.error(err);
          return;
        }
        try {
          result = JSON.parse(response);
        } catch (e) {
          that.loadding = false;
          return alert('parse sts response info error: ' + e.message);
        }
        var client = new OSS.Wrapper({
          accessKeyId: result.data.AccessKeyId,
          accessKeySecret: result.data.AccessKeySecret,
          stsToken: result.data.SecurityToken,
          endpoint: result.data.endpoint,
          bucket: result.data.bucket,
          secure: true
        });
        var suffix = file.name.toLowerCase().split('.').splice(-1)[0];
        var myDate = new Date();
        var file_save_name = 'uploader/' + that.getNowFormatDate()  + '/' + file.lastModified + '.' + suffix;
        console.log(file_save_name);
        let thisfile = this;
        client.multipartUpload(file_save_name, file).then(function (result) {
          var file2 = {
            id:file.id,
            url: ossFileURL + '/' + file_save_name+'?x-oss-process=style/tb-750',
            save_name: file_save_name
          }
          console.log('success');
          console.log(file2);
          that.cardPic = file2.url;
          that.orcSubmit(file2.url);
        }).catch(function (err) {
          console.log('上传失败');
          console.log(err);
          that.loadding = false;
          that.$toast(file.name + '上传失败');
        });
      });
    },
    orcSubmit(url){
      let that = this;
      this.$api.post('/api/utils/idOcr', {
        url : url,
      }, r => {
        console.log(r.data);
        that.$emit('success', r.data)
        that.loadding = false;
      },r=>{
        that.$toast(r.msg);
        that.loadding = false;
      })
    },

    getNowFormatDate: function () {
      var date = new Date();
      var seperator1 = "";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      return  year + seperator1 + month + seperator1 + strDate;
    },

  }
};
</script>

<style scoped>
.contain {
  position: relative;
}
.search-box {
  position: fixed;
  z-index: 999;
  width: 100%;
}
.van-search__content {
  background: #efeff4;
}

.user-box {
  margin-bottom: 50px;
}

.createbtn {
  position: fixed;
  bottom: 0;
  width: 100%;
}

.cell-img {
  width: 48px;
  height: 48px;
  float: left;
  border-radius: 50%;
  margin-right: 15px;
}
</style>


// WEBPACK FOOTER //
// IdCardPicker.vue?28d52e78